var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWrenchIcon = function SvgWrenchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 14 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74.546a.666.666 0 0 0-.962.598v4.3a.667.667 0 0 1-.667.667H5.89a.667.667 0 0 1-.667-.667v-4.3A.667.667 0 0 0 4.26.546C2.112 1.604.778 3.736.778 6.11a6.18 6.18 0 0 0 3.11 5.383v1.95c0 .368.3.667.668.667h4.888a.667.667 0 0 0 .667-.667v-1.95a6.18 6.18 0 0 0 3.111-5.383c0-2.374-1.334-4.507-3.482-5.565"
  })));
};
export default SvgWrenchIcon;